module.exports = __webpack_public_path__ + "img/auctions.11409332.svg";